import { LawsuitItemTypeMap, LawsuitListItem } from "@customTypes/responses/lawsuit";
import React from "react";
import {
  BadgeContainer,
  ButtonContainer,
  LawsuitItemBody,
  LawsuitItemContainer,
  LawsuitItemHeaderContainer,
  LawsuitItemTitleContainer,
  TitleText,
  ViewButton,
} from "./styles";
import { Text } from "nectar-ui";
import { FaRegFolder } from "@react-icons/all-files/fa/FaRegFolder";
import LawsuitStatusBadge from "./LawsuitStatusBadge";
import { useHistory } from "react-router-dom";

const getSubtext = (lawsuit: LawsuitListItem) => {
  if (lawsuit.type === "CTE_CASE") return "Caso";
  return `Processo | ${lawsuit.instanceNumber}º grau`;
};

const lawsuitTypeMap: LawsuitItemTypeMap = {
  CTE_CASE: "caso",
  CTE_LAWSUIT: "processo",
};

const LawsuitItem: React.FC<{ lawsuit: LawsuitListItem }> = ({ lawsuit }) => {
  const history = useHistory();

  const handleViewProcessClick = () => {
    history.push(`/lawsuit/${lawsuit.id}`);
  };

  return (
    <LawsuitItemContainer>
      <LawsuitItemBody>
        <LawsuitItemHeaderContainer>
          <FaRegFolder size={16} style={{ alignSelf: "start", marginTop: 3 }} />
          <LawsuitItemTitleContainer>
            <TitleText size="lg" noMargin semiBold>
              {lawsuit.title}
            </TitleText>
            <BadgeContainer>
              <LawsuitStatusBadge status={lawsuit.status} />
            </BadgeContainer>
          </LawsuitItemTitleContainer>
        </LawsuitItemHeaderContainer>
        {lawsuit.lawsuitType && (
          <Text size="lg" noMargin>
            {lawsuit.lawsuitType}
          </Text>
        )}
        <Text size="lg" noMargin color="gray">
          {getSubtext(lawsuit)}
        </Text>
      </LawsuitItemBody>
      <ButtonContainer>
        <ViewButton onClick={handleViewProcessClick} outline color="primary" block>
          {`Visualizar ${lawsuitTypeMap[lawsuit.type]}`}
        </ViewButton>
      </ButtonContainer>
    </LawsuitItemContainer>
  );
};

export default LawsuitItem;
